var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "registration-success-container" }, [
    _c("h2", [_vm._v("Your request has been sent successfully.")]),
    _c("p", [
      _vm._v(
        "The DRC Team will create log in credentials for you and you will receive an email confirmation with your Guest account details."
      )
    ]),
    _c("button", { on: { click: () => _vm.$router.push("/sign-in") } }, [
      _vm._v("GO BACK TO LOGIN")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }